const getLDContext = function(userData) {
  return {
    kind: 'user',
    key: userData?.id,
    email: userData?.email,
    type: 'APPRAISER_USER',
    company_name: userData?.company?.name,
    company_id: userData?.company?.id,
    _meta: {
      privateAttributes: ['email'],
    },
  }
}

const defaultAnonymousContext = {
  kind: 'user',
  anonymous: true,
  key: 'unidentified_init_user',
  name: 'init_user',
  company_name: 'init_company',
  email: 'init_user@reggora.com',
  type: 'APPRAISER_USER',
  _meta: {
    privateAttributes: ['email'],
  },
}

export { defaultAnonymousContext, getLDContext }
